export default __webpack_public_path__ + "static/media/ArrowDisabled.1b982f17.svg";